import './DisinfectionMeasureCategory.scss'

const DisinfectionMeasureCategory = ({ heading, supportedMeasures, icon }) => {
  const supported = !!supportedMeasures.length
  const src = `/assets/image/listings/${icon}.svg`

  return (
    <div styleName="wrapper">
      <div styleName="icon-wrapper">
        <img styleName="icon" src={src} alt={heading}/>
        { supported && <img styleName="correct" src="/assets/image/listings/correct.svg" alt="対応済み"/> }
      </div>
      <div>
        <h4 styleName="measurement-heading">{heading}</h4>
        { supported &&
          <ul styleName="measurement-list">
            { supportedMeasures.map(({ name }, index) => <li key={index}>{name}</li>)}
          </ul>
        }
      </div>
    </div>
  )
}
export default DisinfectionMeasureCategory
